module.exports = __webpack_public_path__ + "img/Porto Apartment - 61 of 85.a319ae9b.jpeg";